<template>
  <b-form-group>
    <b-input-group class="flex-nowrap align-items-center">
      <b-form-input
        class="bg-white w-75 mr-3"
        :placeholder="$t('global.verification-code')"
        type="tel"
        :state="validateState"
        v-model="verificationCode"
      ></b-form-input>
      <div @click="refreshCode">
        <Identify :identifyCode="identifyCode" :backgroundColorMin="255" :backgroundColorMax="255" />
      </div>
    </b-input-group>
    <b-form-invalid-feedback :state="validateState">{{validateWording}}</b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import Identify from '@/components/verificationCode/Identify.vue';
import commonTool from '@/utils/commonTool';

export default {
  created() {
    const vm = this;
    vm.refreshCode();
  },
  data() {
    return {
      verificationCode: '',
      identifyCode: '',
      validateWording: '',
      validateState: undefined,
    };
  },
  components: { Identify },
  methods: {
    // 產生{l}位數的亂數
    makeCode(l) {
      const vm = this;
      vm.identifyCode = '';
      for (let index = 0; index < l; index += 1) {
        vm.identifyCode += commonTool.randomNum(0, 10);
      }
    },
    // 產生亂數
    refreshCode() {
      const vm = this;
      vm.verificationCode = '';
      vm.makeCode(4);
    },
    // 驗證驗證碼
    verify() {
      const vm = this;
      if (!vm.verificationCode.length) {
        vm.validateWording = vm.$t('global.verification-code-validate.require');
        vm.validateState = false;
      } else if (vm.verificationCode !== vm.identifyCode) {
        vm.validateWording = vm.$t('global.verification-code-validate.error');
        vm.validateState = false;
      } else {
        vm.validateWording = '';
        vm.validateState = undefined;
      }

      vm.refreshCode();
      return vm.validateState === undefined;
    },
  },
  watch: {
    verificationCode() {
      const vm = this;
      vm.verificationCode = commonTool.toSBC(vm.verificationCode);
    },
  },
};
</script>
